/**
 * Created by Lauta on 10/2/2017.
 */

import {BaseRequestOptions, RequestMethod, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/toArray'
import 'rxjs/add/observable/from'
import {Entity} from './entity';
import {QueryOptions} from './query.options';
import {AuthService} from '../security/auth.service';
import {environment} from 'environments/environment';
import {PaginationPage} from './pagination-page';

@Injectable()
export abstract class GenericService<T extends Entity> {

    protected baseUrl: string = environment.backendHost + environment.backendApiPath;

    constructor(protected authService: AuthService) {
    }

    public abstract getDefaultQueryOptions(): QueryOptions;

    protected abstract valueToEntity(value: any): Observable<T> | T;

    protected abstract getResourcePath(): string;

    public query(queryOptions: QueryOptions = this.getDefaultQueryOptions()): Observable<PaginationPage<T>> {
        return this.doRequest(queryOptions.getQueryRequestOptions().merge({
            url: this.baseUrl + this.getResourcePath()
        }))
            .map(res => res.json())
            .concatMap(json => Observable.from(json.content)
                .concatMap(value => this.mapValueToEntityQuery(value))
                .toArray()
                .map(content => new PaginationPage({...json, content: content}))
            );
    }

    public getAll(): Observable<T[]> {
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/all',
            method: RequestMethod.Get
        })
            .concatMap(res => Observable.from(res.json())
                .concatMap(value => this.mapValueToEntityGetAll(value))
                .toArray()
            )
    }

    public get(id: number): Observable<T> {
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/' + id,
            method: RequestMethod.Get
        }).do(console.log)
            .concatMap(res => this.mapValueToEntityGet(res.json()));
    }

    public create(t: T): Observable<T> {
        return this.doRequest({
                url: this.baseUrl + this.getResourcePath(),
                method: RequestMethod.Post,
                body: JSON.stringify(t)
            })
            .concatMap(res => this.mapValueToEntity(res.json()));
    }

    public update(t: T): Observable<T> {
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath(),
            method: RequestMethod.Put,
            body: JSON.stringify(t)
        })
            .concatMap(res => this.mapValueToEntity(res.json()));
    }

    public delete(t: number | T): Observable<number> {
        const id = typeof t !== 'number' ? (t as T).id : t as number;
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/' + id,
            method: RequestMethod.Delete
        })
            .map(res => id);
        /*
        const req = this.buildRequest(RequestMethod.Delete);
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + '/' + t.id, req)
            .map(res => res.ok);
        */
    }


    protected buildRequest(method: RequestMethod, body: string = '', options = {}): RequestOptions {
        const reqOptions = new BaseRequestOptions();
        reqOptions.method = method;
        reqOptions.body = body;
        const ro = reqOptions.merge(options);
        if (!ro.headers.has('Content-Type')) {
            ro.headers.append('Content-Type', 'application/json');
        }
        return ro;
    }

    protected doRequest(requestOptions: RequestOptionsArgs): Observable<Response> {
        let options = new BaseRequestOptions();
        options = options.merge(requestOptions);
        if (!options.headers.has('Content-Type')) {
            options.headers.append('Content-Type', 'application/json');
        }
        return this.authService.authRequest(options.url, options);
    }

    protected valueToEntityQuery(value: any): Observable<T> | T {
        return this.valueToEntity(value)
    }

    protected valueToEntityGetAll(value: any): Observable<T> | T {
        return this.valueToEntity(value);
    }

    protected valueToEntityGet(value: any): Observable<T> | T {
        return this.valueToEntity(value);
    }

    protected mixedMap<V>(value: V | Observable<V>): Observable<V> {
        return value instanceof Observable ? value : Observable.of(value);
    }

    protected mapValueToEntity(value): Observable<T> {
    	console.log(JSON.stringify(value));
        return this.mixedMap(this.valueToEntity(value));
    }

    protected mapValueToEntityQuery(value): Observable<T> {
        return this.mixedMap(this.valueToEntityQuery(value));
    }

    protected mapValueToEntityGetAll(value): Observable<T> {
        return this.mixedMap(this.valueToEntityGetAll(value));
    }

    protected mapValueToEntityGet(value): Observable<T> {
        return this.mixedMap(this.valueToEntityGet(value));
    }

}



// WEBPACK FOOTER //
// ./src/app/core/commons/generic.service.ts